<template id="landingSwitchTmpl">
	<ct-main-layout-landing>

		<ct-user-info></ct-user-info>

		<v-row no-gutters class="mt-4">
							
			<v-col cols="12" md="4" class="pa-2" v-for="item in apps" v-bind:key="item.ID">

				<v-card outlined>
					<v-card-title style="text-align: center;">
						<v-icon color="white" class="mr-2" v-if="item.ID == 'a002'">visibility</v-icon>
						<v-icon color="white" class="mr-2" v-else-if="item.ID == 'a001'">work</v-icon>
						<v-icon color="white" class="mr-2" v-else-if="item.ID == 'a003'">build</v-icon>
						
						<span v-if="item.ID == 'a002'">{{ $t('swicther.title_appgui') }}</span>
						<span v-else-if="item.ID == 'a001'">{{ $t('swicther.title_appcommerciale') }}</span>
						<span v-else-if="item.ID == 'a003'">{{ $t('swicther.title_appadmin') }}</span>
						<span v-else>{{ $root.findTranslationInList(item.name) }}</span>
					</v-card-title>
					
					<v-card-text>
						<span v-if="item.ID == 'a002'">{{ $t('swicther.description_appgui') }}</span>
						<span v-else-if="item.ID == 'a001'">{{ $t('swicther.description_appcommerciale') }}</span>
						<span v-else-if="item.ID == 'a003'">{{ $t('swicther.description_appadmin') }}</span>
						<span v-else>{{ $root.findTranslationInList(item.description)}}</span>
					</v-card-text>
					
					<v-card-actions class="justify-center mt-4 mb-4">
						<v-btn class="button-main" @click="$root.goToPage('/' + item.app_url)" >{{ $t('btn.landingEnterApp')}}</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>

		</v-row>

	</ct-main-layout-landing>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
	i18n,
	data: () => ({
		apps: [],
	}),
	mounted() {
		this.loadUserApps();
	},
	methods: {
		loadUserApps()
		{
			var userObj = this.getUser();	
			if(!this.isEmptyObj(userObj) && !this.isEmptyObj(userObj.Applications) ){
				this.apps = userObj.Applications;
			}
		}
		
	}
}
</script>